<template>
    <b-row v-if="pagination">
        <b-col
            md="6"
            class="mb-1 mb-md-0"
        >
            <b-badge variant="info">
                {{ pagination.from || 0 }} - {{ pagination.to || 0 }}
            </b-badge>
            <b-badge variant="warning">
                {{ productCount }} / {{ pagination.total }}
            </b-badge>
            <b-badge variant="success">
                Sayfa: {{ pagination.current_page }} / {{ pagination.last_page }}
            </b-badge>
        </b-col>
        <b-col md="6">
            <b-form-group
                label="Sayfa başına ürün"
                label-cols="auto"
                class="mb-1"
            >
                <b-form-select
                    :value="perPage"
                    :options="[10, 25, 50, 100, 500, 1000]"
                    :disabled="disabled"
                    size="sm"
                    aria-label="Sayfa başına ürün sayısı"
                    @change="$emit('perPageChange', Number($event))"
                />
            </b-form-group>
            <b-pagination
                :value="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.per_page"
                :disabled="disabled"
                limit="9"
                align="right"
                first-number
                last-number
                class="pagination-success mb-0"
                size="sm"
                @page-click="pageClick"
            />
        </b-col>
    </b-row>
</template>

<script>
    import {
        BRow, BCol, BBadge, BPagination, BFormGroup, BFormSelect,
    } from 'bootstrap-vue'

    export default {
        name: 'ProductPagination',
        components: {
            BRow, BCol, BBadge, BPagination, BFormGroup, BFormSelect,
        },
        props: {
            pagination: {
                type: Object,
                default: null,
            },
            perPage: {
                type: Number,
                default: 25,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            productCount() {
                const { total, per_page: perPage, current_page: currentPage } = this.pagination
                return Math.max(0, Math.min(perPage, total - (currentPage - 1) * perPage))
            },
        },
        methods: {
            pageClick(bvEvent, page) {
                bvEvent.preventDefault()
                if (!this.disabled) this.$emit('pageClick', page)
            },
        },
    }
</script>
